module.exports = fox._r("images/social_icons/ico-yt.png", __webpack_public_path__ + "_/_/_/root/images/social_icons/ico-yt.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/images/social_icons/ico-yt.png
// module id = 948
// module chunks = 4